import React from 'react';

import { ReactComponent as FuelIcon } from '../../icons/hero-fuel.svg';
import { ReactComponent as GoalIcon } from '../../icons/hero-goal.svg';
import { ReactComponent as MacrosIcon } from '../../icons/hero-macros.svg';

import './hero.scss';

const HERO_FEATURES = [
  { Icon: GoalIcon, label: 'Choose your goal' },
  { Icon: MacrosIcon, label: 'Pick your macros' },
  { Icon: FuelIcon, label: 'Fuel your life' }
];

const Hero = ({ onClick }) => {
  return (
    <div className="hero" style={{ backgroundImage: 'url(/images/hero.png)' }} onClick={onClick}>
      <div className="hero__scrim" />

      <div className="hero__content">
        <span className="hero__eyebrow">Build your</span>
        <span className="hero__title">
          <span className="hero__title-accent">Perfect</span>
          <br />
          Meal
        </span>
        <span className="hero__subtitle">
          Customise every gram.
          <br />
          Track every macro. Fuel your goals.
        </span>

        <div className="hero__features">
          {HERO_FEATURES.map(({ Icon, label }) => (
            <span className="hero__feature" key={label}>
              <Icon className="hero__feature-icon" />
              <span className="hero__feature-label">{label}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
